// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1eUGc","calendarButtons":"ClockData_calendarButtons__3JjRo"};